<script>import validator from "validator";
import InputInline from "../InputInline.svelte";
import { undefOrNull } from "../../../../utils/objects";
export let props;
const checkEmail = (v) => undefOrNull(v) || validator.isEmpty(v) || validator.isEmail(v);
if (props) {
  props.validation = props.validation ?? { rules: [] };
  props.validation = {
    ...props.validation,
    rules: [
      ...props.validation.rules ? props.validation.rules : [],
      {
        label: props.emailValidationRuleLabel,
        check: checkEmail
      }
    ]
  };
}
</script>

<InputInline type="email" bind:props on:focus />
